import Vue from 'vue'
import VueRouter from 'vue-router'
// import Home from '../views/Home.vue'

Vue.use(VueRouter)

  const routes = [
  {
    path: '/',
    name: 'Home',
    // redirect: '/ar'
    component: () => import(/* webpackChunkName: "about" */ '../views/Home.vue')
  },

  {
    path: '/about',
    name:'About',
    component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
  },
  {
    path: '/contact',
    name:'Contact',
    component: () => import(/* webpackChunkName: "credits" */ '../views/Contact.vue')
  },

  {
    path: '/ar',
    name:'AR',
    component: () => import(/* webpackChunkName: "credits" */ '../views/AR.vue')
  }
]

const router = new VueRouter({
  mode: 'history',
  routes: routes
})

export default router
